class LogoWall extends HTMLElement {
  activeLogoIndex = 0;
  hoveredLogoIndex = null;
  quotes = [];
  logos = [];
  logosWrapper;
  logoWall;
  interval;

  constructor() {
    super();
  }

  connectedCallback() {
    this.quotes = this.querySelectorAll('.logo-wall__quote-inner-wrapper');
    this.logos = this.querySelectorAll('.logo-wall__logo-inner-wrapper');
    this.logosWrapper = this.querySelector('.logo-wall__logo-wrapper');
    this.logoWall = this.querySelector('.logo-wall');

    this.adjustStylesWhenScrollable();
    this.playInLoop();

    if (this.logos.length > 1) {
      this.logos.forEach((logo, logoIndex) =>
        logo.addEventListener('mouseover', () => {
          this.stopLoop();
          this.hoveredLogoIndex = logoIndex;
          this.activeLogoIndex = logoIndex;
          this.applyStyles();
        })
      );
      this.logos.forEach((logo) =>
        logo.addEventListener('mouseleave', () => {
          this.hoveredLogoIndex = null;
          this.playInLoop();
          this.applyStyles();
        })
      );
    }
  }

  playInLoop = () => {
    if (this.logos.length >= 2 && !this.hoveredLogoIndex) {
      this.interval = setInterval(() => {
        this.changeActiveIndex();
        this.applyStyles();
      }, 15000);
    }
  };

  stopLoop = () => clearInterval(this.interval);

  changeActiveIndex = () => {
    if (this.activeLogoIndex !== this.logos.length - 1) {
      this.activeLogoIndex = this.activeLogoIndex + 1;
    } else {
      this.activeLogoIndex = 0;
    }
  };

  applyStyles = () => {
    this.logos.forEach((logo, logoIndex) =>
      logo.classList.toggle('logo-wall__logo-inner-wrapper--active', logoIndex === this.activeLogoIndex)
    );
    this.quotes.forEach((quote, logoIndex) =>
      quote.classList.toggle('logo-wall__quote-inner-wrapper--active', logoIndex === this.activeLogoIndex)
    );
  };

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  adjustStylesWhenScrollable = () => {
    if (this.logosWrapper.scrollWidth > this.logosWrapper.clientWidth) {
      this.logosWrapper.style.justifyContent = 'flex-start';
    }
  };
}

customElements.define('logo-wall', LogoWall);
